<div v-if= 'token_exists' class="card border bg-transparent rounded-5 d-none d-xl-block " >
    <h6 class="card-header bg-transparent text-muted">Business Profiles</h6>
    <div v-for="profile in filtered_business" :key="profile.id">
      <div class="d-flex align-items-center mt-1 p-1 user-row px-3" @click="view_profile(profile)">
        <img
  :src="profile.base_profile.profile_files.length > 0
          ? profile.base_profile.profile_files[0]?.file.file_url
          : profile.base_profile.profile_files[0]?.file.file_url || require('@/assets/images/briefcase.png')"
  class="me-2 rounded-circle profile-list-avatar pointer"
  alt="Business Logo"
/>
        <p class="mb-1 small fw-500 pointer">{{profile.company_name}}</p>
      </div>
    </div>
      <div v-if="business_profiles.length > visibleCount" class="overflow-auto p-0 full-width-mobile scrollable-container text-center mt-3">
        <a class="text-decoration-none fs-italic text-xxs" href="/view_business_profiles">
          {{ showAll ? 'See Less' : 'See More' }}
        </a>
      </div>
  </div>



